import GlobalModule from './modules/global';
import AccountModule from './modules/account/index';

import LogActionsModule from './modules/logActions/index';

import ProjectsModule from './modules/projects/index';
import SupportExtTicketsModule from './modules/supportExtTickets/index';
import SupportTicketsModule from './modules/supportTickets/index';

import DocsKnowledgebasePages from './modules/docs/knowledgebasePages/index';
import DocsKnowledgebaseGroups from './modules/docs/knowledgebaseGroups/index';
import DocsChangelog from './modules/docs/changelog/index';

export default {
  g: GlobalModule,
  account: AccountModule,

  logActions: LogActionsModule,
  projects: ProjectsModule,
  'docs/knowledgebasePages': DocsKnowledgebasePages,
  'docs/knowledgebaseGroups': DocsKnowledgebaseGroups,
  'docs/changelog': DocsChangelog,
  'support-ex-tickets': SupportExtTicketsModule,
  'support-tickets': SupportTicketsModule,
};
